import styled from 'styled-components';
import { Colors } from '../../shared/colors/colors';
import { StyleSheet } from "@react-pdf/renderer";

export const PageContainer = styled.div`
  padding: 50px;  
  display: flex;
  gap: 32px;
  flex-direction: column;
`;

export const PageTitle = styled.h1`
  color: ${Colors.primary};
  margin-bottom: 20px;
`;

export const Card = styled.div`
  background: ${Colors.white};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  // padding: 20px;
 
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px;


  h2 {
    color: ${Colors.primary};
    margin: 0;
  }
`;


// export const BlueTitle = styled.h1`
//   margin: 0;
//   width: 50%;
//   max-height: 10px;
//   font-weight: 500;
//   font-size: 20px;
//   line-height: 20px;
//   font-weight: 600; /* Alterado para bold */

// `;

export const TitleAndButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

`;




export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  gap: 10px;
`;

export const ButtonWrapper = styled.div`
  margin-right: 8px;
`;

export const ActionButton = styled.button`
  background-color: ${Colors.primary};
  color: ${Colors.white};
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${Colors.secondary};
  }

  &:disabled {
    background-color: ${Colors.disabled};
    cursor: not-allowed;
  }
`;

export const ContainerModal = styled.div`
  padding: 20px;
`;

export const CloseButtonContainer = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: ${Colors.secondary};
  
  &:hover {
    color: ${Colors.primary};
  }
`;

export const InputContainer = styled.div`
  margin-bottom: 15px;
`;

export const SelectContainer = styled.div`
  margin-bottom: 15px;
`;

export const RowContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 15px;
`;

export const TableContainer = styled.div`
  overflow-x: auto;
  margin-top: 20px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 800px;
`;

export const TableHead = styled.thead`
  background-color: ${Colors.backgroundColorTable};
`;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: ${Colors.backgroundColorTable};
  }
`;

export const TableHeader = styled.th`
  padding: 12px;
  text-align: left;
  color: ${Colors.fontColorTable};
  font-weight: 600;
  border-bottom: 1px solid ${Colors.borderColorModalBody};
`;

export const TableData = styled.td`
  padding: 12px;
  color: ${Colors.fontColorTable};
  border-bottom: 1px solid ${Colors.borderColorModalBody};
`;

export const TableBody = styled.tbody`
  tr:nth-child(even) {
    background-color: #f8f9fa;
  }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  color: ${Colors.label};
  font-weight: 500;
`;

export const SaldoInfo = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
`;

export const SaldoCard = styled.div<{ tipo?: 'entrada' | 'saida' }>`
  background: ${({ tipo }) =>
    tipo === 'entrada' ? Colors.success + '20' :
      tipo === 'saida' ? Colors.danger + '20' :
        Colors.primary + '20'};
  border-radius: 8px;
  padding: 15px;
  flex: 1;

  h3 {
    color: ${({ tipo }) =>
    tipo === 'entrada' ? Colors.success :
      tipo === 'saida' ? Colors.danger :
        Colors.primary};
    margin: 0 0 5px 0;
  }

  p {
    font-size: 1.5em;
    font-weight: bold;
    margin: 0;
    color: ${({ tipo }) =>
    tipo === 'entrada' ? Colors.success :
      tipo === 'saida' ? Colors.danger :
        Colors.primary};
  }
`;

export const FluxoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
`;

export const FluxoInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1rem;
  background: #f8f9fa;
  border-radius: 4px;

  span {
    font-size: 1rem;
    color: #6c757d;
  }

  strong {
    font-size: 1.2rem;
    &.positive {
      color: #28a745;
    }
  }
`;

export const CaixaAtualContainer = styled.div`
  background: ${Colors.white};
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  h2 {
    color: ${Colors.primary};
    margin-bottom: 15px;
    font-size: 1.5rem;
  }

  div {
    margin-bottom: 10px;
    font-size: 1rem;
    
    strong {
      color: ${Colors.primary};
      margin-right: 8px;
    }
  }
`;

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const LoadingGif = styled.img`
  width: 100px;
  height: 100px;
`;

export const Button = styled.button`
  background: ${Colors.primary};
  color: ${Colors.white};
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    background: ${Colors.disabled};
    cursor: not-allowed;
  }
`;

export const ManualPaymentTablecontainer = styled.div`
   padding: 10px;
   margin-bottom: 10px;
`

export const SummaryTableMainContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
  margin-right: 38px;
`;

export const SummaryTableContainer = styled.div`
  margin-left: auto; // Pushes the container to the right
  display: flex;
  justify-content: flex-end;
`;

export const RelatorioStyles = StyleSheet.create({
  page: { padding: 30, position: "relative" },

  // Cabeçalho
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 20,
    position: "relative",
  },
  logoContainer: {
    position: "absolute",
    left: 50,
    top: 0,
    width: 45,
    height: 45,
  },
  logo: {
    width: 45,
    height: 45,
  },
  headerText: {
    flex: 1,
    alignItems: "center",
  },
  institution: { fontSize: 12, fontWeight: "bold" },
  details: { fontSize: 8 },
  title: { fontSize: 14, fontWeight: "bold", marginTop: 10 },

  // Filtros
  filters: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: 8,
    gap: 8,
  },
  filterText: {
    fontSize: 12,
  },

  // Tabela
  table: { display: "flex", width: "auto", marginTop: 20 },
  row: { flexDirection: "row" },
  cellHeader: {
    fontWeight: "bold",
    padding: 5,
    width: "14%",
    fontSize: 8,
    backgroundColor: Colors.backgroundColorTable,
    border: `1px solid ${Colors.black}`,
  },
  cellHeaderName: {
    fontWeight: "bold",
    padding: 5,
    width: "34%",
    fontSize: 8,
    backgroundColor: Colors.backgroundColorTable,
    border: `1px solid ${Colors.black}`,
  },
  cell: {
    padding: 5,
    width: "14%",
    fontSize: 7,
    border: `1px solid ${Colors.black}`,
  },
  cellName: {
    padding: 5,
    width: "34%",
    fontSize: 8,
    border: `1px solid ${Colors.black}`,
  },
  cellBold: {
    padding: 5,
    width: "14%",
    fontSize: 7,
    border: `1px solid ${Colors.black}`,
    fontWeight: "bold",
  },
  cellFourSpace: {
    padding: 5,
    width: "76%",
    fontSize: 7,
    border: `1px solid ${Colors.black}`,
  },

  // Rodapé
  footer: {
    position: "absolute",
    bottom: 20,
    left: 30,
    right: 30,
    fontSize: 9,
    flexDirection: "row",
    justifyContent: "space-between",
    color: "#555",
  },

  tableContainerSummary: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "18px",
    alignItems: "flex-end",
  },

  tableSummary: {
    width: "90%"
  }
});